function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

// lazyload
(function (window, factory) {
  // universal module definition
  if ((typeof module === "undefined" ? "undefined" : _typeof(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory(require('./core'), require('fizzy-ui-utils'));
  } else {
    // browser global
    factory(window.Flickity, window.fizzyUIUtils);
  }
})(typeof window != 'undefined' ? window : this, function factory(Flickity, utils) {
  var lazyAttr = 'data-flickity-lazyload';
  var lazySrcAttr = "".concat(lazyAttr, "-src");
  var lazySrcsetAttr = "".concat(lazyAttr, "-srcset");
  var imgSelector = "img[".concat(lazyAttr, "], img[").concat(lazySrcAttr, "], ") + "img[".concat(lazySrcsetAttr, "], source[").concat(lazySrcsetAttr, "]");

  Flickity.create.lazyLoad = function () {
    this.on('select', this.lazyLoad);
    this.handleLazyLoadComplete = this.onLazyLoadComplete.bind(this);
  };

  var proto = Flickity.prototype;

  proto.lazyLoad = function () {
    var _this = this;

    var lazyLoad = this.options.lazyLoad;
    if (!lazyLoad) return; // get adjacent cells, use lazyLoad option for adjacent count

    var adjCount = typeof lazyLoad == 'number' ? lazyLoad : 0; // lazy load images

    this.getAdjacentCellElements(adjCount).map(getCellLazyImages).flat().forEach(function (img) {
      return new LazyLoader(img, _this.handleLazyLoadComplete);
    });
  };

  function getCellLazyImages(cellElem) {
    // check if cell element is lazy image
    if (cellElem.matches('img')) {
      var cellAttr = cellElem.getAttribute(lazyAttr);
      var cellSrcAttr = cellElem.getAttribute(lazySrcAttr);
      var cellSrcsetAttr = cellElem.getAttribute(lazySrcsetAttr);

      if (cellAttr || cellSrcAttr || cellSrcsetAttr) {
        return cellElem;
      }
    } // select lazy images in cell


    return _toConsumableArray(cellElem.querySelectorAll(imgSelector));
  }

  proto.onLazyLoadComplete = function (img, event) {
    var cell = this.getParentCell(img);
    var cellElem = cell && cell.element;
    this.cellSizeChange(cellElem);
    this.dispatchEvent('lazyLoad', event, cellElem);
  }; // -------------------------- LazyLoader -------------------------- //

  /**
   * class to handle loading images
   * @param {Image} img - Image element
   * @param {Function} onComplete - callback function
   */


  function LazyLoader(img, onComplete) {
    this.img = img;
    this.onComplete = onComplete;
    this.load();
  }

  LazyLoader.prototype.handleEvent = utils.handleEvent;

  LazyLoader.prototype.load = function () {
    this.img.addEventListener('load', this);
    this.img.addEventListener('error', this); // get src & srcset

    var src = this.img.getAttribute(lazyAttr) || this.img.getAttribute(lazySrcAttr);
    var srcset = this.img.getAttribute(lazySrcsetAttr); // set src & serset

    this.img.src = src;
    if (srcset) this.img.setAttribute('srcset', srcset); // remove attr

    this.img.removeAttribute(lazyAttr);
    this.img.removeAttribute(lazySrcAttr);
    this.img.removeAttribute(lazySrcsetAttr);
  };

  LazyLoader.prototype.onload = function (event) {
    this.complete(event, 'flickity-lazyloaded');
  };

  LazyLoader.prototype.onerror = function (event) {
    this.complete(event, 'flickity-lazyerror');
  };

  LazyLoader.prototype.complete = function (event, className) {
    // unbind events
    this.img.removeEventListener('load', this);
    this.img.removeEventListener('error', this);
    var mediaElem = this.img.parentNode.matches('picture') ? this.img.parentNode : this.img;
    mediaElem.classList.add(className);
    this.onComplete(this.img, event);
  }; // -----  ----- //


  Flickity.LazyLoader = LazyLoader;
  return Flickity;
});